import React, { useContext } from "react";
import styled from "styled-components";
import { UserContext } from "../../contexts/UserContext"; // Adjust the path as needed
import Button from "../../interface/Button";
import Modal from "../../interface/Modal";
import LoginForm from "./LoginForm";

const Avatar = styled.img`
  width: 1.8em;
  height: 1.8em;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 0.5em;
  cursor: pointer;
  vertical-align: middle; // Align vertically
  //transform: translateY(-0.2em); // Adjust as needed
`;

const StyledUser = styled.h1`
  display: flex; // Enables Flexbox
  align-items: center; // Centers children vertically
  font-size: 1.2em;
  color: var(--color-grey-600);
  padding-left: 1em;
  cursor: pointer;
`;

function User() {
  const { userDetails } = useContext(UserContext);
  const { isMobile } = userDetails;

  const defaultAvatar = "/images/DefaultUser.png";

  return (
    <>
      {isMobile ? (
        <Modal>
          <Modal.Open opens="login">
            <StyledUser>
              <Avatar
                src={userDetails.userImage || defaultAvatar}
                alt="User Avatar"
              />
            </StyledUser>
          </Modal.Open>
          <Modal.Window name="login">
            <LoginForm />
          </Modal.Window>
        </Modal>
      ) : (
        <Modal>
          <Modal.Open opens="login">
            <StyledUser>
              <Avatar
                src={userDetails.userImage || defaultAvatar}
                alt="User Avatar"
              />
              {userDetails.userName || userDetails.userEmail || "Login"}
            </StyledUser>
          </Modal.Open>
          <Modal.Window name="login">
            <LoginForm />
          </Modal.Window>
        </Modal>
      )}
    </>
  );
}

export default User;
